export const YT_SDK_URL = "https://www.youtube.com/iframe_api";
export const YT_GLOBAL_KEY_NS = "YT";
export const YT_GLOBAL_API_READY_EV = "onYouTubeIframeAPIReady";
